<ng-template #addToCart let-product>
  <div class="add-to-cart-container">
    <mat-checkbox [checked]="additionalProductIsSelected(product.id)"
      [labelPosition]="'before'"
      (change)="setAdditionalProductIsSelected(
                    product.id, $event.source.checked)">
      <a mat-raised-button size="small" color="primary">
        {{ 'i18n.additionalProducts.addToCart' | translate }}
      </a>
    </mat-checkbox>
  </div>
</ng-template>

<ng-template #secondaryProduct let-product
    let-hook="hook" let-description="description">
  <div class="secondary-product">
    <div class="product-image">
      <img src="{{ getImageURL(product) }}" alt=""/>
    </div>
    <div class="hook"><b>{{ product.shortName }}:</b> {{ hook }}</div>
    <div class="description">{{ description }}</div>
    <price-display [showAsAddition]="true"
      [price]="priceCalculationService.getProductPriceWithFeatures(product)"
      [quantity]="product.quantity">
    </price-display>
    <ng-container
      *ngTemplateOutlet="addToCart; context: {$implicit: product}">
    </ng-container>
  </div>
</ng-template>

<div class="additional-products-selection">
  @if (frame) {
    <div class="frame-product">
      <div class="product-image">
        <img class="size-reference" src="{{ getImageURL(frame) }}" alt=""
          aria-hidden="true"/>
        <img class="preview" src="{{ getImageURL(frame) }}" alt=""/>
      </div>
      <div class="product-content">
        <div class="emotional-hook">
          {{ 'i18n.additionalProducts.frame.emotionalHook' | translate }}
        </div>
        <div class="subtitle"
          [innerHTML]="'i18n.additionalProducts.frame.subtitle' | translate">
        </div>
        <price-display [showAsAddition]="true"
          [price]="priceCalculationService.getProductPriceWithFeatures(frame)"
          [quantity]="frame.quantity">
        </price-display>
        <div class="description">
          @if (frame.type === types.FRAME_2023) {
            {{ 'i18n.additionalProducts.frame2023.description'
                | translate }}
          } @else if (frame.type === types.FRAME_PLASTIC) {
            {{ 'i18n.additionalProducts.framePlastic.description'
                | translate }}
          } @else {
            {{ 'i18n.additionalProducts.frame.description'
                | translate }}
          }
        </div>
        @if (frameColorGroup) {
          <div class="color-swatches">
            @for (feature of objToArray(frameColorGroup.features);
                  track feature.id) {
              @let isSelected = feature.id === frameColorGroup.selectedFeature;
              <button type="button" class="color-swatch"
                [class.selected]="isSelected"
                [attr.aria-pressed]="isSelected"
                [title]="feature.shortName"
                (click)="selectFrameColor(feature.id)">
                <img [src]="feature.images[0]?.smallURL"
                  [alt]="feature.shortName" />
                <span class="color-swatch-name">
                  {{ feature.shortName }}
                </span>
              </button>
            }
          </div>
        }
        <ng-container
          *ngTemplateOutlet="addToCart; context: {$implicit: frame}">
        </ng-container>
      </div>
    </div>
  }

  @if (glue || roll) {
    @if (frame) {
      <hr />
    }
    <div class="secondary-products">
      @if (glue) {
        <ng-container *ngTemplateOutlet="secondaryProduct; context: {
            $implicit: glue,
            hook: 'i18n.additionalProducts.glue.hook' | translate,
            description: 'i18n.additionalProducts.glue.description' | translate
          }">
        </ng-container>
      }
      @if (roll) {
        <ng-container *ngTemplateOutlet="secondaryProduct; context: {
            $implicit: roll,
            hook: 'i18n.additionalProducts.roll.hook' | translate,
            description: 'i18n.additionalProducts.roll.description' | translate
          }">
        </ng-container>
      }
    </div>
  }
</div>
<div class="total-price">
  <hr />
  <span class="label">{{ 'i18n.price.total' | translate }}: </span>
  <span class="price">
    {{ priceCalculationService.currentTotal.reducedAmount | priceFormat }}
  </span>
  @if (priceCalculationService.currentTotal.reduction > 0) {
    <div class="reduction-price">
      {{ 'i18n.price.reduction' | translate }}
      {{ priceCalculationService.currentTotal.reduction | priceFormat }}
    </div>
  }
</div>
<progress-buttons></progress-buttons>
